import { of } from 'rxjs';
import { HttpBackend, HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class BimElementService {
    constructor(http, httpBackend // Client Http permettant de bypasser l'intercepteur qui affiche les messages d'erreur
    ) {
        this.http = http;
        this.httpBackend = httpBackend;
        this.resourceUrl = environment.apiUrl + '/bim-info';
        this.httpNoInterceptor = new HttpClient(httpBackend);
    }
    element(id) {
        return this.http.get(`${this.resourceUrl}/elements/${id}`);
    }
    elementBasic(id) {
        return this.http.get(`${this.resourceUrl}/elements/${id}?basic=true`);
    }
    /**
     * Renvoie une version basique de l'élément, ou null si une erreur s'est produite.
     */
    elementBasicNoError(id) {
        return this.httpNoInterceptor.get(`${this.resourceUrl}/elements/${id}?basic=true`).pipe(catchError(_ => of(null)));
    }
    elementParent(id, typeElement) {
        const params = new HttpParams().set('typeElement', typeElement);
        return this.http.get(`${this.resourceUrl}/elements/${id}/parent`, { params });
    }
    elementsAdjacents(id) {
        return this.http.get(`${this.resourceUrl}/elements/${id}/adjacents`);
    }
    elementsChildren(id, typeElement) {
        const params = new HttpParams().set('typeElement', typeElement);
        return this.http.get(`${this.resourceUrl}/elements/${id}/children`, { params });
    }
    basicBatimentChildren(elementId, typeElement, typeOuvrageId, includeParents = false) {
        let params = new HttpParams().set('typeElement', typeElement).set('includeParents', String(includeParents));
        if (typeOuvrageId) {
            params = params.set('typeOuvrageId', typeOuvrageId);
        }
        return this.http.get(`${this.resourceUrl}/elements/${elementId}/basic-children`, { params });
    }
    getBulkUpdateUrl(elementId) {
        return `${this.resourceUrl}/elements/${elementId}/bulk-update`;
    }
    // *******************
    // IMAGES
    // *******************
    uploadImage(elementId, formData, replacementFileId) {
        let params = new HttpParams();
        if (replacementFileId) {
            params = params.set('replacementFileId', replacementFileId);
        }
        return this.http.post(`${this.resourceUrl}/elements/${elementId}/images`, formData, {
            params,
            reportProgress: true,
            observe: 'events'
        });
    }
    deleteImage(elementId, fileId) {
        return this.http.delete(`${this.resourceUrl}/elements/${elementId}/images/${fileId}`);
    }
    getImageData(elementId, image) {
        return this.httpNoInterceptor.get(`${this.resourceUrl}/elements/${elementId}/images/${image.fileId}/data`, { responseType: 'text' }).pipe(catchError(_ => of('')));
    }
}
BimElementService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BimElementService_Factory() { return new BimElementService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i1.HttpBackend)); }, token: BimElementService, providedIn: "root" });
